'use client';

import { ComponentProps } from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

import { APP_THEME_MODE_STORE_STORAGE_KEY } from '../theme';

export function ThemeProvider({
  children,
  ...props
}: ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      disableTransitionOnChange
      enableColorScheme
      enableSystem
      storageKey={APP_THEME_MODE_STORE_STORAGE_KEY}
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
